import React from "react";
import Option from "./Option";
import "./FoodItem.css";

export default function OptionList({
  options,
  addonId,
  foodItemQuantity,
  optionButtonId,
  selectedOptions,
  // onOptionToggle,
  onRadioOptionToggle,
  onCheckboxOptionToggle,
  onOptionQuantityChange,
  onSubOptionChange,
}) {
  return (
    <div className='option-list'>
      <p className='thTitle'>Select any</p>
      {options?.map((option) => (
        <Option
          key={option.optionId}
          addonId={addonId}
          option={option}
          foodItemQuantity={foodItemQuantity}
          optionButtonId={optionButtonId}
          selectedOption={selectedOptions?.[option.optionId]}
          // onOptionToggle={onOptionToggle}
          onRadioOptionToggle={onRadioOptionToggle}
          onCheckboxOptionToggle={onCheckboxOptionToggle}
          onOptionQuantityChange={onOptionQuantityChange}
          onSubOptionChange={onSubOptionChange}
        />
      ))}
    </div>
  );
}
